export default __webpack_public_path__ + "static/media/lysningen-property-18.b35006f8.jpg";